import { Component, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { RewardsComponent } from "../dialogs/rewards/rewards.component";
import { TrackingActions } from "../../state-management/tracking/tracking.action";
import { AppState } from '../../interfaces/app-state.interface';
import { DialogsService } from '../../services/dialogs.service';

@Component({
    selector: 'rewards-gift-button',
    templateUrl: './rewards-gift-button.component.html',
    styleUrls: ['./rewards-gift-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class RewardsGiftButtonComponent {
    constructor(
        private store: Store<AppState>,
        private dialogsService: DialogsService
    ) {}
 
    /**
 * Abre o overlay com o grafico
 */
    public openRewards(): void {
        this.trackingMixpanel({
            action: 'User Clicked',
            element: 'btn-rewards',
        });

        this.dialogsService.showComponnent(RewardsComponent);
    }

    /**
    * Trackear mixpanel: fluxo platform
    */
    private trackingMixpanel(events: any): void {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: 'Rewards Gift Button',
                events,
            },
        });
    }
}